// extracted by mini-css-extract-plugin
export default {"blockedIssueIconWrapper":"item-state-module__blockedIssueIconWrapper--hyhnR","issueIcon":"item-state-module__issueIcon--l7LBK","blockedIcon":"item-state-module__blockedIcon--zrsqp"};